import { useState, useEffect } from 'react';

export const useCountdown = (seconds: number, isCountingDownDefault = true) => {
  const [countdown, setCountdown] = useState<number>(
    isCountingDownDefault ? seconds : 0
  );
  const [isCountingDown, setIsCountingDown] = useState<boolean>(
    isCountingDownDefault
  );

  const startCounter = () => {
    setCountdown(seconds);
    setIsCountingDown(true);
  };

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (countdown !== 0) {
      interval = setInterval(
        () =>
          setCountdown(prev => {
            if (prev === 1) {
              setIsCountingDown(false);
              return 0;
            }
            return prev - 1;
          }),
        1000
      );
    }

    return () => clearInterval(interval);
  }, [isCountingDown, undefined]);

  return { startCounter, isCountingDown, countdown };
};
